const LOGOS = [
    "UL300a Certified",
    "Intertek Listed",
    "NFPA 17A Aligned",
    "Same-Day Install Support",
    "Free Video Training",
    "Licensed Installers",
    "Fire Marshal Ready",
    "Made in USA",
];

export default function TrustStrip() {
    const items = [...LOGOS, ...LOGOS];
    return (
        <section
            data-testid="trust-strip"
            className="relative border-y border-white/10 bg-[#0a0a0b] overflow-hidden"
        >
            <div className="py-6 flex overflow-hidden">
                <div className="flex marquee gap-12 whitespace-nowrap min-w-[200%]">
                    {items.map((item, i) => (
                        <div
                            key={`${item}-${i}`}
                            className="flex items-center gap-3 font-mono-tech text-[12px] uppercase tracking-[0.22em] text-[#a1a1aa]"
                        >
                            <span className="w-1 h-1 bg-[#E53935] rounded-full" />
                            {item}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
